import { useId, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { Navbar, Sidebar } from '../components';
import type { ContentType } from '../routes/routesConfig';
import { normalizeContentType } from '../routes/routesConfig';

function HomePage() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const overlayId = useId();
  const mainContentId = useId();

  // Get current content type using centralized configuration
  const currentContent: ContentType = normalizeContentType(location.pathname);

  const handleOverlayKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <div
      className="min-h-screen-safe bg-background-secondary safe-area-all"
      role="application"
      aria-label="Aplicação principal"
    >
      <Navbar
        onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      />

      {/* Spacing to compensate for the fixed navbar */}
      <div className="pt-20">
        {/* Sidebar */}
        <Sidebar
          isOpen={isMobileMenuOpen}
          onToggle={() => setIsMobileMenuOpen(false)}
          currentContent={currentContent}
        />

        {/* Mobile overlay */}
        {isMobileMenuOpen && (
          <div
            id={overlayId}
            className="fixed inset-0 z-40 lg:hidden"
            onClick={() => setIsMobileMenuOpen(false)}
            onKeyDown={handleOverlayKeyDown}
            role="button"
            tabIndex={0}
            aria-label="Fechar menu de navegação"
            aria-hidden={!isMobileMenuOpen}
          />
        )}

        {/* Render the current route's content */}
        <main
          id={mainContentId}
          role="main"
          aria-label="Conteúdo principal"
          className="focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default HomePage;
